<template>
  <div>
    <div v-if="(jobStatus && jobStatus.status === 'in-progress') && (jobInProgress && jobInProgress.status === 'in-progress')">
      <el-alert
        style="margin-bottom: 10px;"
        :closable="false"
      >
        <div style="margin-left: -10px; margin-bottom: 3px">
          <i class="el-icon-loading"></i> Időszaki munkák hozzáadása jelenleg folyamatban van.
        </div>
      </el-alert>
      <el-progress
        style="margin-bottom: 20px;"
        :text-inside="true"
        :stroke-width="20"
        :percentage="jobInProgress.percent"
      />
    </div>
    <el-card>
      <div slot="header">
        Időszaki munkák

        <el-button
          v-can="'todo.create'"
          :disabled="(jobStatus && jobStatus.status === 'in-progress') && (jobInProgress && jobInProgress.status === 'in-progress')"
          style="float: right; margin-top: -5px;"
          type="success"
          size="small"
          icon="el-icon-plus"
          @click="$router.replace('/representative-processes/tasks/add')"
        >
          Új időszaki munka
        </el-button>
        <el-popover
          v-model="deleteConfirmVisible"
          placement="bottom"
          width="171"
          trigger="click"
          style="float:right; margin-top: -5px; margin-right: 5px"
        >
          <p>Biztosan törölni szeretnéd?</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="deleteConfirmVisible = false"
            >
              Mégse
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteTasks"
            >
              Törlés
            </el-button>
          </div>
          <el-button
            slot="reference"
            v-can="'process.task.delete'"
            :loading="deleteButtonLoader"
            :disabled="$refs['list'] && !$refs['list'].idsToDelete.length"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            Kijelöltek törlése
          </el-button>
        </el-popover>
      </div>
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="task/fetchAll"
      />
      <task-list
        ref="list"
      />
      <template v-if="$route.meta.showAddTaskDialog">
        <task-dialog
          type="add"
        />
      </template>
      <template v-if="$route.meta.showUpdateTaskDialog">
        <task-dialog
          type="update"
          :taskId="$route.params.id"
        />
      </template>
      <template v-if="$route.meta.showTaskViewDialog">
        <task-view-dialog
          :task-id="$route.params.id"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
import TaskList from '../../components/representativeProcesses/tasks/List';
import TableFilter from '../../components/TableFilter';
import TaskDialog from '../../components/representativeProcesses/tasks/Dialog';
import TaskViewDialog from '../../components/representativeProcesses/tasks/View'

export default {
  components: {
    TaskList,
    TableFilter,
    TaskDialog,
    TaskViewDialog,
  },
  data() {
    return {
      filterConfig: null,
      jobInProgress: null,
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
    };
  },
  computed: {
    jobStatus() {
      return this.$store.getters['job/jobs'].find(j => j.name === 'add_representative_tasks');
    },
  },
  async mounted() {
    Echo.channel('representativeTasks')
      .listen('.status', (data) => {
        this.jobInProgress = data;
      });
    await this.$store.dispatch('job/fetchAll');
    await this.setConfig();
  },
  methods: {
    async deleteTasks() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      const data = this.$refs['list'].idsToDelete;
      try {
        await axios.post('api/tasks/delete', data);
      } catch (e) {
      }
      this.deleteButtonLoader = false;
      this.$store.dispatch('task/fetchAll');
    },
    getShopName(shop) {
      if (!shop) {
        return '';
      }
      let shopName = shop.name;
      const shopNameLength = shopName.length;
      if (shopNameLength > 10) {
        shopName = shopName.substring(0, 10) + '...';
      }
      return `#${shop.id} ${shopName}`;
    },
    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'title',
          label: 'Megnevezés',
          defaultSearch: true,
        },
        {
          type: 'multipleRemoteSelect',
          name: 'shop_id',
          label: 'Üzlet',
          labelCallback: shop => this.getShopName(shop),
          optionLabelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'shop/search',
        },
        {
          type: 'select',
          name: 'type',
          label: 'Típus',
          options: [
            {
              label: 'Disztribuciós felmérés',
              type: 'measure'
            },
            {
              label: 'Képkészítés',
              type: 'photo'
            },
            {
              label: 'Kérdőív',
              type: 'questionnaire'
            },
          ],
          labelCallback: status => status.label,
          valueKey: 'type',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Kész',
              status: 'done'
            },
            {
              label: 'Folyamatban',
              status: 'in-progress'
            },
            {
              label: 'Elintézendő',
              status: 'todo'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: users,
          name: 'user_id',
          label: 'Felelős',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
      ];
    }
  },
};
</script>
